module.exports = __webpack_public_path__ + "assets/images/extintor_33fc07d7c3b11fa3c8d1886f091cfdcf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yellow/cilindro/extintor.png
// module id = 188
// module chunks = 0